const STATIC_404_GIF_PATH = '/media/static/404.gif';
const DEV_B2B_ORIGIN = 'https://dev2b.molo.com';

/** Origin for legacy `/media/static/*` assets when the SPA is not served from the .NET site. */
export function localDevStaticOrigin(): string {
    const host = window.location.hostname;
    if (
        host === 'localhost' ||
        host === '127.0.0.1' ||
        host.endsWith('.molo.local')
    ) {
        return DEV_B2B_ORIGIN;
    }
    return '';
}

export function static404GifUrl(): string {
    return localDevStaticOrigin() + STATIC_404_GIF_PATH;
}

/**
 * Fallback for card banner images. Avoids infinite onError loops when the SPA serves HTML for /media/static/404.gif.
 */
export function handleCardBannerImageError(
    event: React.SyntheticEvent<HTMLImageElement, Event>,
    onImageSettled?: () => void,
): void {
    const img = event.currentTarget;
    const fallbackUrl = static404GifUrl();

    if (img.dataset.fallbackApplied === '1') {
        img.onerror = null;
        if (onImageSettled) {
            onImageSettled();
        }
        return;
    }

    img.dataset.fallbackApplied = '1';
    img.src = fallbackUrl;
}
